




// document.addEventListener('DOMContentLoaded', function () {
//   const variants = JSON.parse(
//     document.getElementById('product-variants-json').textContent
//   );

//   const stockText = document.getElementById('variant-stock-text');
//   const addToCartBtn = document.querySelector('.product-form__submit');
//   const notifyBtn = document.querySelector('.klaviyo-bis-trigger');
//   const variantInput = document.querySelector('input[name="id"].product-variant-id');

//   if (!variantInput || !stockText || !addToCartBtn) return;

//   function updateStock(variantId) {
//     const variant = variants.find(v => v.id == variantId);
//     if (!variant) return;

//     /* ===== INVENTORY NOT TRACKED ===== */
//     if (!variant.inventory_management) {
//       stockText.textContent = 'In Stock';
//       stockText.classList.remove('disabled');

//       addToCartBtn.disabled = false;
//       addToCartBtn.querySelector('span').textContent = 'Add to cart';

//       if (notifyBtn) notifyBtn.style.display = 'none';
//       return;
//     }

//     /* ===== INVENTORY TRACKED ===== */
//     if (variant.inventory_quantity <= 0) {
//       stockText.textContent = 'Out of Stock';
//       stockText.classList.add('disabled');

//       addToCartBtn.disabled = true;
//       addToCartBtn.querySelector('span').textContent = 'Unavailable';

//       if (notifyBtn) notifyBtn.style.display = 'inline-block';

//     } else if (variant.inventory_quantity <= 10) {
//       stockText.textContent = `Only ${variant.inventory_quantity} left in stock`;
//       stockText.classList.remove('disabled');

//       addToCartBtn.disabled = false;
//       addToCartBtn.querySelector('span').textContent = 'Add to cart';

//       if (notifyBtn) notifyBtn.style.display = 'none';

//     } else {
//       stockText.textContent = 'In Stock';
//       stockText.classList.remove('disabled');

//       addToCartBtn.disabled = false;
//       addToCartBtn.querySelector('span').textContent = 'Add to cart';

//       if (notifyBtn) notifyBtn.style.display = 'none';
//     }
//   }

//   /* Initial load */
//   updateStock(variantInput.value);

//   /* Watch variant changes */
//   const observer = new MutationObserver(() => {
//     updateStock(variantInput.value);
//   });

//   observer.observe(variantInput, {
//     attributes: true,
//     attributeFilter: ['value']
//   });
// });





$(document).ready(function(){
$(document).on("click", ".custom_filter", function () {
  const $filters = $("#main-collection-filters");
  const $title = $(this).find("h3");
  $filters.toggle();
  if ($filters.is(":visible")) {
    $title.text("Hide Filter");
  } else {
    $title.text("Filter");
  }
});


$(document).ready(function () {

  // =========================
  // FACETS BORDER
  // =========================
  $(document).on("click", ".active-facets__button-wrapper a", function () {
    $(".active-facets.active-facets-desktop").css("border-top", "1px solid #ccc");
  });


  // =========================
  // POPUP MODALS (UNIVERSAL)
  // =========================

  // OPEN MODAL (works for ALL question-link classes)
  $(document).on("click", ".question-link", function (e) {
    e.preventDefault();

    // get second class (availability, shipping, etc.)
    var classes = $(this).attr("class").split(" ");
    var modalClass = classes.find(cls => cls !== "question-link");

    var $wrapper = $(".product-modals");
    var $modal = $(".product-modals .modal." + modalClass);

    if ($wrapper.length && $modal.length) {
      $wrapper.addClass("active");

      // remove old active
      $(".product-modals .modal").removeClass("active");

      // open current
      $modal.addClass("active");
    } else {
      console.log("Modal not found:", modalClass);
    }
  });


  // CLOSE MODAL (only when clicking outside)
  $(".product-modals").on("click", function (e) {
    if ($(e.target).is(".product-modals") || $(e.target).hasClass("background")) {
      $(this).removeClass("active");
      $(".product-modals .modal").removeClass("active");
    }
  });


  // =========================
  // INQUIRE / CUSTOMIZE FORM
  // =========================
  var btn_txt = $('.customize-form-trigger').text();

  $('.customize-form-trigger').on('click', function (event) {
    event.preventDefault();

    $('.customize-form').toggleClass('active');

    if ($('.customize-form').hasClass('active')) {
      $(this).text('Close');
    } else {
      $(this).text(btn_txt);
    }
  });

});


  // toggle Inquire form end
// deafult template add chekd attribut in the size
$('.custom__variant').click(function() {
     var radioInput = $(this).closest('.variant_block').find('input[type="radio"]');
        $('input[name="' + radioInput.attr('name') + '"]').attr('checked', false);

        // Check the radio input associated with the clicked label
        radioInput.attr('checked', true);
    });
});




$(document).ready(function(){
function Default_templatejs(){
    var custom_val1 = $(".custom__var--1 input:checked").val();
    var custom_val2 = $(".custom__var--2 input:checked").val();
    var custom_val3 = $(".custom__var--3 input:checked").val();
    
    $(".variant__name-1").html(custom_val1);
    $(".variant__name-2").html(custom_val2);
    $(".variant__name-3").html(custom_val3);

    var finalop = '';
    if (custom_val1) {
        finalop += custom_val1;
      }
    if (custom_val2) {
        finalop += (finalop ? ' / ' : '') + custom_val2;
      }
      if (custom_val3) {
        finalop += (finalop ? ' / ' : '') + custom_val3;
      }

    $('.custom__combo-variant option').removeAttr('selected');
    var comoboo_cst_mm =  $(".custom__combo-variant option").map(function () {
      if ($(this).attr("data-option"))
      return $(this).attr("data-option");
      }).get();
      if(jQuery.inArray(finalop.toString(), comoboo_cst_mm) >= 0){   
        $('.custom__combo-variant option[data-option="' + finalop + '"]').attr("selected", "selected");  
        var selected_product_id = $(".custom__combo-variant").find(":selected").val();
        var sku = $(".custom__combo-variant").find(":selected").attr('data-var-sku');
           $(".details-nav .detail").find(".detailss__sku").html(sku);
        $('.custom__deafultsku').val(sku); 
      }
}
Default_templatejs();
$(".custom__var--1 input,.custom__var--2 input, .custom__var--3 input ").click(function(){Default_templatejs();});

$(".slides").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    infinite:true,
    dots: false,
    vertical: true,
    draggable: false,
    verticalSwiping: true,
    pauseOnHover: false,
    mousewheelControl: true,
    responsive: [
      {
        breakpoint: 989,
        settings: {
          arrows: true,
          slidesToShow: 3,
          infinite:true
        }
      },
        {
        breakpoint: 749,
        settings: {
          arrows: true,
          slidesToShow: 4,
          infinite:true
        }
      }
    ]
  });    
 $(".product-thumb").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    infinite:true,
    dots: false,
    draggable: false,
    pauseOnHover: false,
    mousewheelControl: true,
    responsive: [
        {
        breakpoint: 749,
        settings: {
          arrows: false,
          slidesToShow: 6,
          infinite:true,
          arrows: true
        }
      },
              {
        breakpoint: 590,
        settings: {
          arrows: false,
          slidesToShow: 4,
          infinite:true,
          arrows: true
        }
      }
    ]
  });
  $('.play-rend-hero').on('click', function(){
   $('body .home-banner .banner-content .banner-video .responsive-video__wrapper.init .video-init-container .still-wrapper').toggle(); 
});
  $('.filter-toggle').click(function(){
    $('.filter-wrapper').slideToggle();
     $('.filter-wrapper').css('opacity', '1');
});
  $('.filter-group.shipping button').click(function(){
    var ship_filter = $(this).attr('data-filter');
   $('.filter-button').removeClass('selected');
      $(this).addClass('selected');
    if(ship_filter == '.reset'){
   $('.collection-item').css('display', 'block'); 
 } else{
    $('.collection-item').css('display', 'none');
    $('.collection-item' + ship_filter).css('display', 'block'); 
 }
  
});
  $('.variant_block input').on('click', function(){
   if($(this).hasClass('disabled')){
     $('.detail.stock').addClass('disabled');
    $('.primary-details').addClass('disabled');
 }
  else{
     $('.detail.stock').removeClass('disabled');
     $('.primary-details').removeClass('disabled');
    }
});
  $(".custom__fabric_scroll ul li a").on("click", function(event) {
    event.preventDefault();
    var hash = this.hash;
    var offset = $(window).width() < 768 ? 50 : 150;
    $("html, body").animate({
        scrollTop: $(hash).offset().top - offset
    }, 1000);
});

$(".mobile__nav_swatch select").on("change", function(event) {
    var scroll_attr = $(this).find('option:selected').attr('datascroll');
    var offset = $(window).width() < 768 ? 50 : 150;
    var target = $("#" + scroll_attr);

    if (target.length) {
        $("html, body").animate({
            scrollTop: target.offset().top - offset
        }, 1000); 
    }
});
   if ($(".product-description-truncate").prop("scrollHeight") <= $(".product-description-truncate").prop("clientHeight")) {
        $("#read-more").hide(); // Hide "Read more" if no overflow
    }

    $("#read-more").click(function () {
        $("#truncated-description").hide();
        $("#full-description").show();
        $(this).hide(); // Hide "Read more"
    });

    $("#read-less").click(function () {
        $("#truncated-description").show();
        $("#full-description").hide();
        $("#read-more").show(); // Show "Read more" again
    });
}); 